import { Router, Route, Redirect, Switch } from "wouter";
import Login from "./components/Pages/Login";
import AdminDashboard from "./components/Pages/Admin/AdminDashboard";
import ManagementDashboard from "./components/Pages/Management/ManagementDashboard";
import Transactions from "./components/Pages/Transactions";
import EmployeeDashboard from "./components/Pages/Employees/EmployeeDashboard";
import Projects from "./components/Pages/Projects";
import EmployeeProject from "./components/Pages/Employees/EmployeeProject";
import { useUser } from "./components/Use-auth";
import Account from "./components/Pages/Account";
import { DateRangeProvider } from "./components/Pages/DateRangeContext";
import LogoutOnTabClose from "./components/LogoutOnTabClose";
import HrDashBoard from "./components/Pages/Hr/HrDashBoard";
import HolidaysAndPolicies from "./components/Pages/Holidays & Policies";
import Setting from "./components/Pages/Setting";
import Category from "./components/Pages/Category";
import MyTeam from "./components/Pages/MyTeam";
import LeaveAndAttendence from "./components/Pages/LeaveAndAttendence";
import Expenses from "./components/Pages/Expenses";
import MemberPasswordSetUp from "./components/ui/MemberPasswordSetUp";
import Hiring from "./components/Pages/Hiring";
import Letters from "./components/Pages/Letters";
import PayRoll from "./components/Pages/PayRoll";
import SalesDashboard from "./components/Pages/Sales/SalesDashboard";
import SalesLead from "./components/Pages/Sales/SalesLead";
import LeadContacts from "./components/Pages/Sales/Contacts";
import ActiveContacts from "./components/Pages/Sales/ActiveContacts";
import IsAdminHr from "./components/Pages/Admin/IsAdmin&Hr";
import ForgotPassword from "./components/ui/ForgotPassword";
import ResetPassword from "./components/ui/ResetPassword";
import ForceLogoutChecker from "./components/Pages/ForceLogoutChecker";
import NotFound from "./components/Pages/not-found";
import SessionStorageClose from "./components/SessionStorageClose";
import { decryptData } from "./lib/crypto";

function ProtectedRoute({ component: Component, allowedDepartments, blockSales }) {
  const { data: user, isLoading } = useUser();

  if (isLoading) return null;
  if (!user) return <Redirect to="/login" />;

  const isSales = user.department === "Sales";

  if (blockSales && isSales) {
    return <Redirect to="/sales-dashboard" />;
  }

  if (allowedDepartments && !allowedDepartments.includes(user.department)) {
    switch (user.department) {
      case "Admin":
        return <Redirect to="/admin" />;
      case "Management":
        return <Redirect to="/management" />;
      case "HR":
        return <Redirect to="/hr-dashboard" />;
      case "Sales":
        return <Redirect to="/sales-dashboard" />;
      case "Design":
        return <Redirect to="/dashboard" />;
      case "Development":
        return <Redirect to="/dashboard" />;
      default:
        return <Redirect to="/" />;
    }
  }

  return <Component />;
}

function HomeRedirect() {
  const { data: user, isLoading } = useUser();
  const encryptedUser = localStorage.getItem("auth_user");
  const auth = encryptedUser ? decryptData(encryptedUser) : null;
  
  if (isLoading) return null;

  if (isLoading && !auth) {
    return <Redirect to="/login" />;
  }

  if (!user && !auth) {
    return <Redirect to="/login" />;
  }
  const department = user?.department || auth?.department;

  switch (department) {

    case "Admin":
      return <Redirect to="/admin" />;

    case "Management":
      return <Redirect to="/management" />;

    case "HR":
      return <Redirect to="/hr-dashboard" />;

    case "Sales":
      return <Redirect to="/sales-dashboard" />;

    case "Design":
      return <Redirect to="/dashboard" />;

    case "Development":
      return <Redirect to="/dashboard" />;

    default:
      return <Redirect to="/dashboard" />;
  }
}

function PublicRoute({ component: Component }) {
  const { data: user, isLoading } = useUser();

  if (isLoading) return null;

  if (user) {
    switch (user.department) {
      case "Admin":
        return <Redirect to="/admin" />;
      case "Management":
        return <Redirect to="/management" />;
      case "HR":
        return <Redirect to="/hr-dashboard" />;
      case "Sales":
        return <Redirect to="/sales-dashboard" />;
      case "Design":
        return <Redirect to="/dashboard" />;
      case "Development":
        return <Redirect to="/dashboard" />;
      default:
        return <Redirect to="/" />;
    }
  }

  return <Component />;
}

function App() {
  return (
    <DateRangeProvider>
      {/* <LogoutOnTabClose />
      <SessionStorageClose /> */}
      {/* <SessionStorageClose /> */}
      {/* <LogoutOnTabClose /> */}

      <ForceLogoutChecker />

      <Router>
        <Switch>
          <Route path="/login">
            <PublicRoute component={Login} />
          </Route>

          <Route path="/admin">
            <ProtectedRoute component={AdminDashboard} allowedDepartments={["Admin"]} />
          </Route>
          <Route path="/hr">
            <ProtectedRoute component={IsAdminHr} allowedDepartments={["Admin"]} />
          </Route>
          <Route path="/myTeam">
            <ProtectedRoute component={MyTeam} allowedDepartments={["Admin", "HR"]} />
          </Route>
          <Route path="/expenses">
            <ProtectedRoute component={Expenses} allowedDepartments={["HR"]} />
          </Route>
          <Route path="/hiring">
            <ProtectedRoute component={Hiring} allowedDepartments={["HR"]} />
          </Route>
          <Route path="/letters">
            <ProtectedRoute component={Letters} allowedDepartments={["Admin", "HR"]} />
          </Route>
          <Route path="/payRoll">
            <ProtectedRoute component={PayRoll} allowedDepartments={["HR"]} />
          </Route>
          <Route path="/leave-tracking">
            <ProtectedRoute
              component={LeaveAndAttendence}
              allowedDepartments={["Admin", "Management", "HR", "Sales", "Design", "Development"]}
            />
          </Route>
          <Route path="/setting">
            <ProtectedRoute component={Setting} allowedDepartments={["Admin", "Management"]} />
          </Route>
          <Route path="/management">
            <ProtectedRoute component={ManagementDashboard} allowedDepartments={["Management"]} />
          </Route>
          <Route path="/transactions">
            <ProtectedRoute component={Transactions} allowedDepartments={["Admin", "Management"]} />
          </Route>
          <Route path="/category">
            <ProtectedRoute component={Category} allowedDepartments={["Admin", "Management"]} />
          </Route>
          <Route path="/hr-dashboard">
            <ProtectedRoute component={HrDashBoard} allowedDepartments={["HR"]} />
          </Route>
          <Route path="/dashboard">
            <ProtectedRoute component={EmployeeDashboard} blockSales allowedDepartments={["Design", "Development"]} />
          </Route>
          <Route path="/sales-dashboard">
            <ProtectedRoute component={SalesDashboard} allowedDepartments={["Sales"]} />
          </Route>
          <Route path="/lead">
            <ProtectedRoute component={SalesLead} allowedDepartments={["Sales",]} />
          </Route>
          <Route path="/lead-contacts">
            <ProtectedRoute component={LeadContacts} allowedDepartments={["Admin", "Sales", "Management"]} />
          </Route>
          <Route path="/active-contacts">
            <ProtectedRoute component={ActiveContacts} allowedDepartments={["Sales"]} />
          </Route>
          <Route path="/project">
            <ProtectedRoute component={EmployeeProject} allowedDepartments={["Sales", "Design", "Development"]} />
          </Route>
          <Route path="/projects">
            <ProtectedRoute component={Projects} allowedDepartments={["Admin", "Management"]} />
          </Route>
          <Route path="/account">
            <ProtectedRoute component={Account} allowedDepartments={["Admin", "HR", "Sales", "Design", "Development", "Management"]} />
          </Route>
          <Route path="/policies">
            <ProtectedRoute component={HolidaysAndPolicies} allowedDepartments={["Admin", "HR", "Sales", "Design", "Development", "Management"]} />
          </Route>

          <Route path="/forgot-password" component={ForgotPassword} />
          <Route path="/reset-password/:token"> <ResetPassword /></Route>
          <Route path="/set-password/:token">  <MemberPasswordSetUp /> </Route>

          <Route path="/" component={HomeRedirect} />
          <Route path="*" component={NotFound} />
        </Switch>
      </Router>
    </DateRangeProvider>
  );
}

export default App;